<script setup>
import { onMounted, ref } from 'vue';
import { get_meta } from '@/helper';

const props = defineProps({
  subscriptionPackage:{
    type: Object,
    required: true
  }
})

const features = ref([])
const showFeatures = ref([])
onMounted(()=>{
  features.value = get_features()
  showFeatures.value = [...features.value].slice(0,2)
})

function get_features(){
  let features = props.subscriptionPackage.meta.find(item=>item.attributes.key == 'features')
  return JSON.parse(features.attributes.value)
}

async function showAll() {
  for (let item of features.value.slice(2)) {
    showFeatures.value.push(item);
    await timeout(500);
  }
}

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
</script>

<template>
  <div class="border-top mt-4 pt-3">
    <!-- Features -->
    <div v-auto-animate>
      <p class="fw-semibold tracking-widest text-uppercase mb-2">Features</p>
      <div class="d-flex align-items-center my-2">
        <div class="icon-border btn-light-success me-2">
          <vue-feather type="check" size="1rem"/>
        </div>
        <p>
          Access to 
          {{ get_meta(subscriptionPackage.meta, 'number_of_trait') }}
          choosen traits
        </p>
      </div>
      <div class="d-flex align-items-center my-2" 
        v-for="item in showFeatures"
      >
        <div class="icon-border btn-light-success me-2">
          <vue-feather type="check" size="1rem"/>
        </div>
        <p>
          {{ item }}
        </p>
      </div>

      <div class="d-flex justify-content-end" @click="showAll()" 
        v-if="showFeatures.length != features.length"
      >
        <button class="btn btn-light-success">
          + {{ features.length - showFeatures.length }} more...
        </button>
      </div>
    </div>
  </div>
</template>